import { getSubscriberInfo } from "../root.selectors";
import { AuthMethod, UserMode } from "@sportal/api";
import { RootState } from "../root.reducer";
import { DEFAULT_TIME_ZONE } from "../attributes/attributes.constants";

export const getSubscriberId = (state: RootState): string =>
  getSubscriberInfo(state).id;

export const getAuthMethod = (state: RootState): AuthMethod =>
  getSubscriberInfo(state).authMethod;

export const isSSO = (state: RootState): boolean =>
  getAuthMethod(state) === AuthMethod.SSO;

export const getUserMode = (state: RootState): UserMode =>
  getSubscriberInfo(state).mode;

export const getDefaultTimezone = (state: RootState): string =>
  getSubscriberInfo(state).defaultTimezone || DEFAULT_TIME_ZONE;

export const getSubscriberName = (state: RootState): string =>
  getSubscriberInfo(state).name;
